module.exports = __webpack_public_path__ + "img/1x2.c2263979.svg";